import React from 'react';
import { ProtectionPlanInformationModalButton } from '../../app/ProtectionPlanInformation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';


export const isProtectionPlanAvailable = (appProtectionPlanValue: any): appProtectionPlanValue is string  => {
  if (typeof appProtectionPlanValue !== 'string') return false;
  return parseFloat(appProtectionPlanValue) > 0
}

export const ProtectionPlanInfo = () => (
  <>
    <h5>Protection Plan</h5>
    <p>The optional Protection Plan covers loss or damage due to fire, theft, or accidental damage.</p>
  </>
)


interface Props {
  portalSlug: string
}


export const ProtectionPlanTerms = (props: Props) => (
  <div className="mt-3">
    Please refer to the{' '}
    <ProtectionPlanInformationModalButton className="btn btn-link p-0 border-0" portalSlug={props.portalSlug} />
    {' '}for a summary of the applicable terms and conditions
  </div>
)
